import clsx from 'clsx'
import Header, { HeaderProps } from '../Header/Header'
import Icon from '../Icon/Icon'

export interface AddressWithHeadingProps {
  /**
   * The main heading for the address, shows above the address lines
   */
  heading: string
  /**
   * Optional subheading for the address, shows below the heading
   */
  subHeading?: string
  /**
   * The lines of the address to display
   */
  addressLines?: string[]
  /**
   * Whether to show the location icon next to the heading
   */
  hasIcon?: boolean
  /**
   * Optional additional classes to apply to the address
   */
  className?: string
  /**
   * The optional heading level to use. Defaults to 'h4'
   */
  headingLevel?: HeaderProps['as']
  /**
   * Optional classes to apply to the children elements
   */
  childrenClassNames?: Partial<
    Record<'icon' | 'heading' | 'addressLines', string>
  >
}

export default function AddressWithHeading({
  heading,
  subHeading,
  addressLines = [],
  hasIcon = true,
  className,
  headingLevel = 'h4',
  childrenClassNames,
}: AddressWithHeadingProps) {
  return (
    <address className={clsx('not-italic', className)}>
      <Header
        as={headingLevel}
        className={clsx(
          'type-body-7 flex items-center',
          childrenClassNames?.heading,
        )}
      >
        {hasIcon && (
          <Icon
            icon="location"
            className={clsx(
              'w-6 h-6 lg:w-4 lg:h-4 mr-2',
              childrenClassNames?.icon,
            )}
          />
        )}
        {heading}
      </Header>
      {subHeading && (
        <Header
          as="h5"
          overrideClassName
          className="type-eyebrow-2 font-normal mt-2"
        >
          {subHeading}
        </Header>
      )}
      <p
        className={clsx('type-body-8 mt-2', childrenClassNames?.addressLines)}
        dangerouslySetInnerHTML={{ __html: addressLines.join('<br />') }}
      ></p>
    </address>
  )
}
